import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OfficeAppsActions" */ './lazyIndex'),
    { name: 'OfficeAppsActions' }
);

export const lazyCreateNewOfficeDoc: LazyAction<
    typeof lazyIndex.createNewOfficeDoc,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.createNewOfficeDoc);
